import React from "react";
import styles from "./styles";
import Typography from "@material-ui/core/Typography";
import iconOnline from "../../../assets/images/icon-online.svg";
import iconPhone from "../../../assets/images/icon-llamada.svg";
import contactImage from "../../../assets/images/contacto.png";
import ArrowForwardIosIcon from "@material-ui/icons/ArrowForwardIos";
import { Divider, Hidden } from "@material-ui/core";

export const ContactSection = () => {
  const classes = styles();
  return (
    <section id="contact" className={classes.mainContainer}>
      <div>
        <Typography component="h2" className={classes.titleSection}>
          Contáctenos
        </Typography>
        <div className={classes.containerDescription}>
          <div className={classes.descriptionSection}>
            Accede a cualquiera de nuestros canales para tener una asistencia
            personalizada
          </div>
        </div>
      </div>
      <div className={`${classes.subSectionContainer} `}>
        <div className={classes.justifyEnd}>
          <div className={classes.leftContainer}>
            <div
              className={`${classes.displayFlex} ${classes.subtitleMargin} ${classes.alignItemCenter}`}
            >
              <img
                src={iconOnline}
                alt="Online"
                className={classes.iconSection}
              />
              <Typography component="p" className={classes.subtitleSection}>
                On line
              </Typography>
            </div>
            <a
              href="https://servicios.saludsa.com.ec/ChatGenesis/informacion.html?x=76&y=10"
              target="_blank"
              rel="noopener noreferrer"
              className={classes.linkContainer}
            >
              <div className={classes.cardContainer}>
                <Typography component="h3" className={classes.titleCard}>
                  Chat en vivo
                </Typography>
                <Typography component="p" className={classes.descriptionCard}>
                  Chatea con un asesor aquí
                </Typography>
                <div className={classes.arrowContainer}>
                  <span className={`${classes.arrowIcon} ${classes.colorGris}`}>
                    <ArrowForwardIosIcon className={classes.iconSize} />
                  </span>
                </div>
              </div>
            </a>
            <a
              href="mailto: vive@saludsa.com.ec"
              target="_blank"
              rel="noopener noreferrer"
              className={classes.linkContainer}
            >
              <div className={classes.cardContainer}>
                <Typography component="h3" className={classes.titleCard}>
                  Correo electrónico
                </Typography>
                <Typography
                  component="p"
                  className={classes.descriptionCard}
                ></Typography>
                <div className={classes.arrowContainer}>
                  <span className={`${classes.arrowIcon} ${classes.colorGris}`}>
                    <ArrowForwardIosIcon className={classes.iconSize} />
                  </span>
                </div>
              </div>
            </a>
            <a
              href="https://api.whatsapp.com/send?phone=+593989404239&text=Hola,%20soy%20cliente%20de%20Saludsa,%20necesito%20servicio%20al%20cliente"
              target="_blank"
              rel="noopener noreferrer"
              className={classes.linkContainer}
            >
              <div className={classes.cardContainer}>
                <Typography component="h3" className={classes.titleCard}>
                  Contactarme por WhatsApp
                </Typography>
                <Typography component="p" className={classes.descriptionCard}>
                  Conectate con un asesor por whatsapp
                </Typography>
                <div className={classes.arrowContainer}>
                  <span className={`${classes.arrowIcon} ${classes.colorGris}`}>
                    <ArrowForwardIosIcon className={classes.iconSize} />
                  </span>
                </div>
              </div>
            </a>
          </div>
        </div>
        {/* <Divider orientation="vertical" flexItem /> */}
        <div className={classes.grandientContainer}>
          <div className={classes.leftContact} style={{ display: "none" }}>
            <div className={`${classes.displayFlex} ${classes.subtitleMargin}`}>
              <img
                src={iconPhone}
                alt="Llamada"
                className={classes.iconSection}
              />
              <Typography component="p" className={classes.subtitleSection}>
                Llamada
              </Typography>
            </div>
            <div className={classes.subtitleMargin}>
              <Typography component="h3" className={classes.titleCard}>
                Servicio al Cliente
              </Typography>
              <Typography component="p" className={classes.descriptionPhone}>
                (593) 26020920 (Quito)
              </Typography>
              <Typography component="p" className={classes.descriptionPhone}>
                (593) 46020920 (Guayaquil)
              </Typography>
            </div>
            <div className={classes.subtitleMargin}>
              <Typography component="h3" className={classes.titleCard}>
                Ventas
              </Typography>
              <Typography component="p" className={classes.descriptionPhone}>
                (593) 26000700
              </Typography>
            </div>
            <div className={classes.subtitleMargin}>
              <Typography component="h3" className={classes.titleCard}>
                Oficinas Administrativas
              </Typography>
              <Typography component="p" className={classes.descriptionPhone}>
                (593) 2500-3040 (Quito)
              </Typography>
              <Typography component="p" className={classes.descriptionPhone}>
                (593) 4500-3040 (Guayaquil)
              </Typography>
            </div>
          </div>
          <Hidden only="sm">
            <div className={classes.containerContactImage}>
              <img
                src={contactImage}
                alt="Contacto"
                className={classes.contactImage}
              />
            </div>
          </Hidden>
        </div>
      </div>
    </section>
  );
};
